import { IBonusHistoryItem, IBonusOperation } from '../types/BonusHistory';

// Ключ операции: у бэкенда своего id нет, а одна и та же пара «время + сумма»
// на соседних страницах — это дубль, который и в списке должен быть одним.
export const toBonusOperation = (item: IBonusHistoryItem): IBonusOperation => ({
  id: `${item.dateTimeUtc}:${item.changeAmount}`,
  date: item.dateTimeUtc,
  amount: Number(item.changeAmount) || 0,
  expiresAt: item.expirationDateTimeUtc,
});
